import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider, UiKitToastsContextProvider } from '@cian/ui-kit/context';
import { FC } from 'react';
import { Provider } from 'react-redux';

import { IApplicationContext } from 'shared/types/applicationContext';
import { ApplicationContext } from 'shared/utils/applicationContext';

import { PageContainer } from '../Page';
import { TReduxStore } from '../../../types/referrer/store';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const Application: FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { initialDeviceType },
  } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={initialDeviceType}>
          <UiKitToastsContextProvider>
            <Provider store={reduxStore}>
              <PageContainer />
            </Provider>
          </UiKitToastsContextProvider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
